export const ACCOUNT_TYPE_OPTIONS = [
  { value: '5', text: 'Basic Bank Account' },
  { value: '9', text: 'Brokerage Account' },
  { value: '14', text: 'Business Account' },
  { value: '17', text: 'Business Loan' },
  { value: '1', text: 'Call Deposit' },
  { value: '19', text: 'Credit Card' },
  { value: '20', text: 'Crypto Wallet' },
  { value: '15', text: 'Current Account' },
  { value: '3', text: 'Escrow Account' },
  { value: '21', text: 'E-Wallet' },
  { value: '22', text: 'Forex Account' },
  { value: '23', text: 'Gaming Account' },
  { value: '25', text: 'Home Loan' },
  { value: '11', text: 'Investment Account' },
  { value: '24', text: 'Loan' },
  { value: '7', text: 'Master Agent Account' },
  { value: '6', text: "Minors' Account" },
  { value: '13', text: 'Other' },
  { value: '26', text: 'Overdraft' },
  { value: '10', text: 'Pension Scheme' },
  { value: '27', text: 'Personal Loan' },
  { value: '12', text: 'Prepaid Card' },
  { value: '18', text: 'Savings Account' },
  { value: '8', text: 'Sub-Account (Gaming)' },
  { value: '28', text: 'Term Deposit Account' },
  { value: '2', text: 'Trading Account' },
  { value: '16', text: 'Trading Account' },
  { value: '4', text: 'Trust Account' },
  { value: 'U', text: 'Unknown' },
] as const;

export type AccountType = (typeof ACCOUNT_TYPE_OPTIONS)[number]['value'] | '';
